import React from "react";
import NavBar from "../NavBar/NavBar";
import Footer from "../Footer/Footer";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import { useTheme } from "@mui/material/styles";
import Banner from "../Banner/Banner";
import { getEnvironmentFromBackendUrl } from "../../utils/utils";

const MainLayout = ({ children, mainSx }) => {
  const theme = useTheme();
  return (
    <Box sx={{ display: "flex", flexDirection: "column", overflow: "hidden" }} style={{ overflow: "hidden" }}>
      <CssBaseline />
      <NavBar />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          overflow: "auto",
          display: "flex",
          width: "100%",
          height: `calc(100vh - ${theme.navbarHeight}px)`,
          backgroundColor: (theme) =>
            theme.palette.mode === "light"
              ? theme.palette.grey[100]
              : theme.palette.grey[900],
          ...mainSx, // Spread additional styles passed via props
        }}
      >
        {children}
      </Box>
      {/* <Footer /> */}
      {getEnvironmentFromBackendUrl(process.env.REACT_APP_BACKEND_URL) ===
        "dev" && <Banner />}
    </Box>
  );
};

export default MainLayout;
